import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import Sidebar from './Sidebar';
import { getAllCategories, createCategory, updateCategory, deleteCategory } from '../api/auth/categoryService';

function Category() {
    const [data, setData] = useState([]);
    const [values, setValues] = useState({
        category: '',
        date: ''
    });
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await getAllCategories();
            setData(response);
        } catch (error) {
            console.error('Error fetching category data:', error);
            Swal.fire('Error!', 'Failed to fetch categories.', 'error');
        }
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const currentDate = new Date().toISOString().split("T")[0];
        const payload = { ...values, date: currentDate };
        
        try {
            if (editingId) {
                // Update
                await updateCategory(editingId, payload);
                Swal.fire('Updated!', 'Category has been updated.', 'success');
                setEditingId(null);
            } else {
                // Create
                
                await createCategory(payload);
                Swal.fire('Created!', 'Category added successfully.', 'success');
            }

            setValues({ category: '', date: '' });
            fetchData();
        } catch (error) {
            console.error('Error saving category:', error);
            Swal.fire('Error!', 'There was a problem saving the category.', 'error');
        }
    };

    const handleEditClick = (item) => {
        setValues({
            category: item.category,
            date: item.date || ''
        });
        setEditingId(item.id);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this entry!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteCategory(id);
                    setData(prev => prev.filter(item => item.id !== id));
                    Swal.fire('Deleted!', 'The category has been deleted.', 'success');
                } catch (error) {
                    Swal.fire('Error!', 'There was a problem deleting the category.', 'error');
                    console.error('Error deleting category:', error);
                }
            }
        });
    };

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-4" style={{ marginLeft: '250px' }}>
                <div className="container-fluid">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <h5 className="page-title">Add Blog Category</h5>
                        </div>
                    </div>

                    {/* Blog Category Form */}
                    <div className="row mt-4">
                        <div className="col-md-6">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Blog Category</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="category"
                                        onChange={handleChanges}
                                        value={values.category}
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    {editingId ? 'Update' : 'Save'}
                                </button>
                                {editingId && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary ms-2"
                                        onClick={() => {
                                            setEditingId(null);
                                            setValues({ category: '', date: '' });
                                        }}
                                    >
                                        Cancel
                                    </button>
                                )}
                            </form>
                        </div>
                    </div>

                    {/* Category Table */}
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Blog category</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.category}</td>
                                            <td>{item.date || 'N/A'}</td>
                                            <td>
                                                <button className="btn btn-primary me-2" onClick={() => handleEditClick(item)}>Edit</button>
                                                <button className="btn btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                    {data.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center">No Blog Category found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Category;